var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../../ModelTraits";
import primitiveTrait from "../../Decorators/primitiveTrait";
import primitiveArrayTrait from "../../Decorators/primitiveArrayTrait";
let TableTimeStyleTraits = (_dec = primitiveTrait({
  name: "Time Column",
  description: "The column that indicates the time of a sample or the start time of an interval.",
  type: "string",
  isNullable: true
}), _dec2 = primitiveTrait({
  name: "End Time Column",
  description: "The column that indicates the end time of an interval.",
  type: "string"
}), _dec3 = primitiveArrayTrait({
  name: "ID Columns",
  description: "The columns that identify an entity as it changes over time.",
  type: "string"
}), _dec4 = primitiveTrait({
  name: "Is Sampled",
  description: 'True if the rows in this CSV correspond to "sampled" data, and so ' + "the feature position, color, and size should be interpolated to produce " + "smooth animation of the features over time. If False, then times are " + "treated as the start of discrete periods and feature positions, colors, and " + "sizes are kept constant until the next time. This value is ignored " + "if the CSV does not have both a time column and an ID column.",
  type: "boolean"
}), _dec5 = primitiveTrait({
  name: "Display Duration",
  type: "number",
  description: "Display duration for each row in the table, in minutes."
}), _dec6 = primitiveTrait({
  name: "Spread start time",
  type: "boolean",
  description: 'Indicates if start time of feature should be "spread" so that all features are displayed at the earliest time step. This is useful for non-contiguous sensor data. If true, the earliest time step will display the earliest values for all features (eg sensor IDs) - even if the time value is **after** the earliest time step. This means that at time step 0, all features will be displayed.'
}), _dec7 = primitiveTrait({
  name: "Spread end time",
  type: "boolean",
  description: 'Indicates if finish time of feature should be "spread" so that all features are displayed at the latest time step. See also `spreadStartTime`.'
}), _class = class TableTimeStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "timeColumn", _descriptor, this);
    _initializerDefineProperty(this, "endTimeColumn", _descriptor2, this);
    _initializerDefineProperty(this, "idColumns", _descriptor3, this);
    _initializerDefineProperty(this, "isSampled", _descriptor4, this);
    _initializerDefineProperty(this, "displayDuration", _descriptor5, this);
    _initializerDefineProperty(this, "spreadStartTime", _descriptor6, this);
    _initializerDefineProperty(this, "spreadFinishTime", _descriptor7, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "timeColumn", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "endTimeColumn", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "idColumns", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isSampled", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "displayDuration", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "spreadStartTime", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "spreadFinishTime", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TableTimeStyleTraits as default };